import { render, staticRenderFns } from "./DraftPost.vue?vue&type=template&id=447c565e"
import script from "./DraftPost.vue?vue&type=script&lang=js"
export * from "./DraftPost.vue?vue&type=script&lang=js"
import style0 from "./DraftPost.vue?vue&type=style&index=0&id=447c565e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports